var acc = document.getElementsByClassName("so-accordion-principle-second");
var i;

$(document).ready(function() {
  $('.so-accordion-principle-second').accordion({
    defaultOpen: 'section1',
    cookieName: 'accordion_nav'
  });
})

for (i = 0; i < acc.length; i++) {
  acc[i].onclick = function() {
    this.classList.toggle("active");
    var panel = this.nextElementSibling;
    if (panel.style.maxHeight){
      panel.style.maxHeight = null;
    } else {
      panel.style.maxHeight = 100 + "%";
      for (j = 0 ; j < acc.length; j++) {
        if (panel == acc[j].nextElementSibling) continue;
        else {
          acc[j].classList.remove("active");
          acc[j].nextElementSibling.style.maxHeight = null;
        }
      }
    }
  }
}


$( "#contentAccordion" ).accordion({
  header: "div.accordion-title", 
  collapsible: true,
  active: false,
  heightStyle: "content" 
}); 
